// Single source for Events: the homepage "Upcoming Events" section and the
// Events Calendar page both read from here.
//
// TODO(refresh): the handoff requires staff to publish events without a
// developer. Once a CMS or API endpoint is chosen, replace `events` with a fetch
// and keep getUpcomingEvents() as the filter.
//
// Fields (all required except endDate):
//   title        string
//   startDate    "YYYY-MM-DDTHH:mm" local time
//   endDate      "YYYY-MM-DDTHH:mm", optional, for multi-day events
//   host         string  e.g. "NEPTA"
//   location     string  venue and city, or "Online"
//   registrationUrl  string
//   summary      string, optional short description
export const events = [];

const endOf = (event) => new Date(event.endDate || event.startDate);

export const getUpcomingEvents = (now = new Date()) =>
  events
    .filter((event) => endOf(event) >= now)
    .sort((a, b) => new Date(a.startDate) - new Date(b.startDate));

const dateFmt = { weekday: "short", month: "short", day: "numeric", year: "numeric" };
const timeFmt = { hour: "numeric", minute: "2-digit" };

export const formatEventDate = (event) => {
  const start = new Date(event.startDate);
  const startText = `${start.toLocaleDateString("en-US", dateFmt)}, ${start.toLocaleTimeString("en-US", timeFmt)}`;
  if (!event.endDate) return startText;
  const end = new Date(event.endDate);
  const sameDay = start.toDateString() === end.toDateString();
  return sameDay
    ? `${startText} – ${end.toLocaleTimeString("en-US", timeFmt)}`
    : `${startText} – ${end.toLocaleDateString("en-US", dateFmt)}`;
};
